export var EventType;
(function (EventType) {
    EventType["HANDSHAKE"] = "handshake";
    EventType["CONNECTION_WELCOME"] = "connection-welcome";
    EventType["CONNECTION_ERROR"] = "connection-error";
    EventType["NOTIFICATION"] = "notification";
    EventType["NOTIFICATION_EVENT"] = "event-notification";
    EventType["USER_EVENT"] = "event-user";
    EventType["DATA_EVENT"] = "event-data";
    EventType["META_EVENT"] = "event-meta";
    EventType["COMMENT_EVENT"] = "event-comment";
    EventType["DASHBOARD_EVENT"] = "event-dashboard";
    EventType["WIDGET_EVENT"] = "event-widget";
    EventType["SCRIPT_EVENT"] = "event-script";
    EventType["TEAM_EVENT"] = "event-team";
    EventType["WORKFLOW_EVENT"] = "event-workflow";
    EventType["WORKFLOW_EXECUTION_EVENT"] = "event-workflow-execution";
})(EventType || (EventType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL3JlYWx0aW1lL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE1BQU0sQ0FBTixJQUFZLFNBZ0JYO0FBaEJELFdBQVksU0FBUztJQUNuQixvQ0FBdUIsQ0FBQTtJQUN2QixzREFBeUMsQ0FBQTtJQUN6QyxrREFBcUMsQ0FBQTtJQUNyQywwQ0FBNkIsQ0FBQTtJQUM3QixzREFBeUMsQ0FBQTtJQUN6QyxzQ0FBeUIsQ0FBQTtJQUN6QixzQ0FBeUIsQ0FBQTtJQUN6QixzQ0FBeUIsQ0FBQTtJQUN6Qiw0Q0FBK0IsQ0FBQTtJQUMvQixnREFBbUMsQ0FBQTtJQUNuQywwQ0FBNkIsQ0FBQTtJQUM3QiwwQ0FBNkIsQ0FBQTtJQUM3QixzQ0FBeUIsQ0FBQTtJQUN6Qiw4Q0FBaUMsQ0FBQTtJQUNqQyxrRUFBcUQsQ0FBQTtBQUN2RCxDQUFDLEVBaEJXLFNBQVMsS0FBVCxTQUFTLFFBZ0JwQiJ9